import { Sku } from '@/interfaces/catalog/Sku'
import API from '@/lib/api'

export const uploadSkuImages = (skuId: string, files: File[]) =>
  API.post<Sku>(`/api/v2/skus/${skuId}/images`, { files }, {
    headers: { 'Content-Type': 'multipart/form-data' },
    formSerializer: { indexes: true },
  })

export const reorderSkuImages = (skuId: string, imageIds: string[]) =>
  API.put<Sku>(`/api/v2/skus/${skuId}/images/order`, { imageIds })

export const deleteSkuImage = (skuId: string, imageId: string) =>
  API.delete<Sku>(`/api/v2/skus/${skuId}/images/${imageId}`)
